module.exports = __webpack_public_path__ + "img/UTFREM-5.2346c40a.jpg";